import React, { ReactNode } from 'react'
import { T } from '@transifex/react'

export type TStripeErrorCode = 'amount_too_large' | `invalid_number`

export const stripeErrorCodeLabelMap: Record<TStripeErrorCode, ReactNode> = {
  amount_too_large: <T _str="Amount too large" />,
  invalid_number: <T _str="Invalid number" />,
}
